module.exports = __webpack_public_path__ + "img/陈旭东.41930c09.jpg";